import React, { useState, useEffect } from 'react';
import WebScheduler from './WebScheduler';
import Timeclock from './Timeclock';
import axios from 'axios';
import Select from 'react-select';
import logoImage from './POCLogo.svg'
import overlayImage from './cutoutT.svg'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import './App.css';
import useWindowSize from './useWindowSize'

//position: absolute;

function App() {
  //helper function to determin if overlay should be shown
  const shouldShowOverlay = () => {
    try {
      const dateNow = Date.now();
      //get the last time the overlay was shown, or 8 hours ago
      const stored = localStorage.getItem('overlay-last-shown') || dateNow - (8 * 60 * 60 * 1000);
      //show the overlay if it was last shown more than an hour ago and set a new time
      if ((dateNow - stored) > (60 * 60 * 1000)) {
        localStorage.setItem('overlay-last-shown', dateNow);
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Error reading date from localStorage:', error);
      return true;
    }
  }

  const [greeting, setGreeting] = useState({ name: '', site: '' });
  const [errorModal, setErrorModal] = useState({ open: false, message: '' });
  const [termsModal, setTermsModal] = useState(false);
  const [siteCode, setSiteCode] = useState('');
  const [siteQuery, setSiteQuery] = useState('');
  const [activeView, setActiveView] = useState('schedule');
  const [overlayClass, setOverlayClass] = useState('overlay-small');
  const [showOverlay, setShowOverlay] = useState(shouldShowOverlay);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [jobs, setJobs] = useState(null);
  const [punches, setPunches] = useState(null);
  const [supportModal, setSupportModal] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(() => {
    try {
      return localStorage.getItem('terms-accepted') === 'true';
    } catch (error) {
      console.error('Error reading terms acceptance from localStorage:', error);
      return false;
    }
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('q');
    const query = urlParams.get('s');
    const decodedSite = decodeURIComponent(query) ?? null;
    console.log("site query: " + decodedSite);
    if (decodedSite) {
      setSelectedSite(decodedSite);
      setSiteQuery(decodedSite);
      console.log("Setting siteQuery to:", decodedSite);
    }
    if (code) {
      setSiteCode(code);
      fetchGreeting(code, query, decodedSite);
    }
    setTimeout(() => {
      setOverlayClass('overlay-large');
      setTimeout(() => {
        setShowOverlay(false);
      }, "2500");      
    }, "2500");    
  }, []);

  const fetchGreeting = async (code, query) => {
    
    var urlTarget;
    if (query) {
      urlTarget = `https://api.precisiononcall.com:8088/api/?q=${code}&s=${encodeURIComponent(query.replace(/['"]+/g, ''))}`;
    } else {
      urlTarget = `https://api.precisiononcall.com:8088/api/?q=${code}`;
    }

    try {
      const response = await axios.get(urlTarget);
      if (response.status === 200) {
        setGreeting({ name: response.data.name, site: response.data.site });
        setJobs(response.data.jobs);
        setPunches(response.data.punches);
        // Handle site list for dropdown
        if (response.data.siteList && response.data.siteList.length > 1) {
          const options = response.data.siteList.map(site => ({
            value: site,
            label: site
          }));
          setSiteOptions(options);
          // Check for saved selection
          /*
          const savedSite = localStorage.getItem('selected-site');
          if (savedSite && options.find(opt => opt.value === savedSite)) {
            setSelectedSite(options.find(opt => opt.value === savedSite));
          }
            */          
        }
      } else {
        const response = await axios.get(`https://ec2-52-14-205-198.us-east-2.compute.amazonaws.com:8050/send`);
        if (response.status === 200) {
            setErrorModal({ open: true, message: `The WebScheduler Server is currently down for maintenance.\nThank you for your patience.` });
        } else {
            setErrorModal({ open: true, message: `Please check your internect connectivity.` });
        }
      }
    } catch (error) {
      try {
        const response = await axios.get(`https://ec2-52-14-205-198.us-east-2.compute.amazonaws.com:8050/send`);
        if (response.status === 200) {
            setErrorModal({ open: true, message: `The WebScheduler Server is currently down for maintenance.\nThank you for your patience.` });
        } else {
            setErrorModal({ open: true, message: `Please check your internect connectivity.` });
        }
      } catch (error) {
          setErrorModal({ open: true, message: `Please check your internect connectivity: ${error.message}` });
      }
    }
  };

  const handleSiteChange = async (selectedOption) => {
    if (selectedOption) {
      setSelectedSite(selectedOption);
      //localStorage.setItem('selected-site', selectedOption.value.replace(/['"]+/g, ''));
      let siteChoice = encodeURIComponent(selectedOption.value.replace(/['"]+/g, ''));
      window.location.assign(`https://api.precisiononcall.com/?q=${siteCode}&s=${siteChoice}`);
    }
  };

  const handleAcceptTerms = async () => {
    setTermsModal(false);
    try {
      localStorage.setItem('terms-accepted', 'true');
      setTermsAccepted(true);
    } catch (error) {
      console.error('Error saving terms acceptance to localStorage:', error);
    }
    try {
      await fetch(`https://api.precisiononcall.com:8088/accept/?q=${siteCode}`, {
        method: 'POST',
      });
    } catch (error) {
      console.error('Error sending terms acceptance:', error);
    }
  };

  const customStyles = {
    menuPortal: base => ({ 
      ...base, 
      zIndex: 999999 
    }),    
    control: (provided) => ({
      ...provided,
      minWidth: '150px',
      fontSize: '12px',
      menu: (original) => {
          return {
            ...original,
            zIndex: 999999
          };
      }
    }),
    placeholder: (normal) => ({
      ...normal,
      fontSize: '12px'
    })
  };

  const size = useWindowSize();

  const handleCloseErrorModal = () => {
    setErrorModal({ ...errorModal, open: false });
  };

  const toggleView = (view) => {
    setActiveView(view);
  };

  return (
    <div className="App">
      {showOverlay && <img src={overlayImage} alt="Overlay" className={overlayClass} />}
      <header className="App-header">
        <div className="header-content">          
          {size.width > 790 && <img src={logoImage} alt="Logo" className="logo" />}
          <div className="greeting">
            <h1>{greeting.name ? `Hello, ${greeting.name}` : ''}</h1>
            <h2>{greeting.site ? `${greeting.site}` : ''}</h2>
            {siteOptions.length > 1 && (
              <Select
                //value={selectedSite}              
                onChange={handleSiteChange}
                options={siteOptions}
                placeholder="select a different site..."
                styles={customStyles}
                isSearchable={true}
                isClearable={true}
                menuPortalTarget={document.body}
              />
            )}
          </div>
          <div className="view-toggles">
            <Button
              size="small"
              variant="contained"
              color={activeView === 'schedule' ? 'primary' : 'default'}
              onClick={() => toggleView('schedule')}
              disabled={activeView === 'schedule'}
            >
              Schedule
            </Button>
            <Button
              size="small"
              variant="contained"
              color={activeView === 'timesheets' ? 'primary' : 'default'}
              onClick={() => toggleView('timesheets')}
              disabled={activeView === 'timesheets'}
            >
              Timesheets
            </Button>
            <Button
              size="small"
              variant="contained"
              color="default"
              onClick={() => setSupportModal(true)}
              startIcon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
                </svg>
              }
            >
              Help
            </Button>
          </div>           
        </div>
      </header>
      {activeView === 'schedule' && <WebScheduler initialSiteCode={siteCode} initialSiteQuery={siteQuery} preloadedJobs={jobs} />}
      {activeView === 'timesheets' && <Timeclock siteCode={siteCode} initialSiteQuery={siteQuery} preloadedPunches={punches} />}
      <Dialog open={errorModal.open} onClose={handleCloseErrorModal}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>{errorModal.message}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={termsModal} onClose={() => setTermsModal(false)} maxWidth="md" fullWidth>
        <DialogTitle>What You Need to Know About Our Terms</DialogTitle>
        <DialogContent dividers style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <p>
            Welcome to the Precision On Call WebScheduler. By using this application, you agree to the following terms and conditions. We know legal documents can be a bit troubling, so here's what matters most in plain English:
          </p>
          <p>
            <strong>1. The Big One: Payment Commitment</strong><br />
            <strong>Booking staff through our online scheduler works the same way as booking via text or email—it's all the same commitment.</strong> When you schedule through this platform, you're agreeing to the same fees and terms outlined in the staffing agreement you already signed with us. The method of booking doesn't change your obligation to pay for the professionals we send.
          </p>
          <p>
            <strong>Other Important Stuff:</strong><br />
          </p>
            <strong>2. Cancellations</strong><br />
          <p>
            <ul>
              <li>
                Need to cancel? No problem—just give us at least 12 hours notice before the scheduled time
              </li>
              <li>
                Cancellations with less than 12 hours notice may come with fees (as outlined in your staffing agreement)
              </li>
            </ul>
          </p>
          <p>
            <strong>3. Your Account</strong><br />
            <ul>
              <li>
                Keep your scheduling info accurate and up to date
              </li>
              <li>
                Keep your login credentials secure—you're responsible for activity on your account
              </li>
            </ul>
            <strong>4. Using the Service Responsibly</strong><br />
            <ul>
              <li>
                Use the platform for legitimate business purposes only
              </li>
              <li>
                Don't try to hack, scrape data, or do anything sketchy
              </li>
              <li>
                Play nice with our system and other users
              </li>
            </ul>
          </p>
          <p>
            <strong>5. Privacy & Data</strong><br />
            <ul>
              <li>
                We only use your data to provide you with surgical staffing services
              </li>
              <li>
                We won't share your information for other purposes
              </li>
              <li>
                We take reasonable steps to keep your data secure
              </li>
            </ul>
          </p>
          <p>
            <strong>6. The Legal Stuff</strong><br />
            <ul>
              <li>
                The service is provided "as is"—we do our best, but can't guarantee perfection
              </li>
              <li>
                These terms are governed by Florida law
              </li>
              <li>
                We can update these terms, and continued use means you accept any changes
              </li>
            </ul>
          </p>
          <hr>
          </hr>
          <p>
            <strong>Questions?</strong>  Reach out anytime at info@precisiononcall.com<br />
            <strong>Technical Assistance?</strong>  Contact Geoff at 727-434-0525 or gcadorette@precisiononcall.com<br />
            <strong>Bottom line:</strong>  Book with confidence, but remember that booking = commitment to pay. We're here to make staffing easy, and we appreciate you being a reliable partner!
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAcceptTerms} color="primary" variant="contained">
            Accept
          </Button>
        </DialogActions>
      </Dialog>
      {!termsAccepted && (
        <Button
          variant="contained"
          color="primary"
          aria-label="Terms and Conditions"
          onClick={() => setTermsModal(true)}
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            zIndex: 999999,
            minWidth: '56px',
            height: '56px',
            borderRadius: '28px',
            padding: '0 20px',
            fontSize: '14px',
            fontWeight: 'bold',
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.35)',
          }}
        >
          Terms and Conditions
        </Button>
      )}
      <Dialog open={supportModal} onClose={() => setSupportModal(false)}>
        <div className="Modal-header">
          <DialogTitle>Tech Support</DialogTitle>
        </div>
        <DialogContent>
          <p>For tech support or questions, contact Geoff:</p>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
            <a href="tel:+17274340525" style={{ textDecoration: 'none' }}>
              727-434-0525
            </a>
          </p>
          <p>
            <a href="tel:+17274340525">Call</a>
            {' \u2022 '}
            <a href="sms:+17274340525">Text</a>
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSupportModal(false)} style={{ backgroundColor: '#607d8b', color: 'white' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default App;